/**
 * QBase 공통 어시스턴트 서비스 클라이언트 — **공통 패키지의 얇은 배선.**
 *
 * 예전에는 이 파일이 204줄짜리 구현이었고, LiveSQL `assistantClient.js` 의 TypeScript 사본이었다.
 * 백엔드는 `assistant-service` 로 공통화됐는데 클라이언트만 복사로 재사용되고 있었다.
 * 구현은 `@qbase/assistant-ui` 로 올라갔고, 여기 남는 것은 **이 앱의 설정을 묶는 일**뿐이다.
 *
 * 내보내는 이름·시그니처는 그대로다 — AssistantPanel·AssistantAccount·SuggestionPanel 은
 * 한 줄도 바뀌지 않는다.
 */
import { createAssistantClient } from '@qbase/assistant-ui';
import { ASSISTANT_API, ASSISTANT_TENANT } from '../config/assistant';

/** 이 앱의 어시스턴트 클라이언트 — 훅에 넘길 때도 이것을 쓴다. */
export const client = createAssistantClient({
  baseUrl: ASSISTANT_API,
  tenantId: ASSISTANT_TENANT,
});

// 메서드는 클로저라 `this` 를 쓰지 않는다 — 그대로 꺼내 써도 안전하다.
export const getAccount = client.getAccount;
export const startLogin = client.startLogin;
export const submitLoginCode = client.submitLoginCode;
export const cancelLogin = client.cancelLogin;
export const logout = client.logout;
export const saveToken = client.saveToken;
export const removeToken = client.removeToken;
export const runTask = client.runTask;
export const listThreads = client.listThreads;
export const createThread = client.createThread;
export const getThread = client.getThread;
export const deleteThread = client.deleteThread;
export const answerQuestion = client.answerQuestion;
/** 클라이언트 도구(client:true) 결과 되돌려주기 — 도움말·샘플 열기 등 화면에서 실행하는 도구 */
export const submitToolResult = client.submitToolResult;
export const abortTurn = client.abortTurn;
export const runTurn = client.runTurn;

export { AssistantError } from '@qbase/assistant-ui';
export type {
  AssistantAccount,
  AssistantThread,
  AssistantMessage,
  AssistantEvent,
  LoginStart,
} from '@qbase/assistant-ui';
